import React, { useEffect, useState } from 'react';
import { Crown, DollarSign, RefreshCw, TrendingUp, TrendingDown } from 'lucide-react';
import api from '../lib/api';
import { useLang, tx } from '../i18n/LanguageContext';

const Stat = ({ icon: Ic, color, value, label, testId }) => (
  <div className="flex items-center gap-3">
    <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${color}`}><Ic className="w-5 h-5" /></div>
    <div className="min-w-0">
      <div className="text-xl font-extrabold text-slate-900" dir="ltr" data-testid={testId}>{value}</div>
      <div className="text-xs text-slate-500 truncate">{label}</div>
    </div>
  </div>
);

const RevenueCard = () => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);

  const load = () => {
    setErr(false);
    api.get('/paypal/admin/stats').then(({ data }) => setS(data)).catch(() => setErr(true));
  };
  useEffect(load, []);

  const money = (v) => `$${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const diff = s ? s.revenue_this_month - s.revenue_last_month : 0;
  const Trend = diff >= 0 ? TrendingUp : TrendingDown;

  return (
    <div data-testid="admin-revenue-card" className="rounded-2xl bg-gradient-to-br from-white to-slate-50 border border-slate-200 p-4 sm:p-5 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-slate-900 font-bold text-sm sm:text-base">{L('الإيرادات والاشتراكات', 'Revenue & Subscriptions')}</h3>
          {s && (
            <span data-testid="revenue-mode-badge" className={`text-[11px] px-2 py-0.5 rounded-full font-bold border ${s.mode === 'live' ? 'bg-green-500/15 text-green-700 border-green-500/40' : 'bg-amber-500/15 text-amber-700 border-amber-500/40'}`}>
              Stripe {s.mode === 'live' ? 'LIVE' : 'TEST'}
            </span>
          )}
        </div>
        <button data-testid="revenue-refresh-btn" onClick={load} className="text-slate-500 hover:text-slate-900 transition-colors" title={L('تحديث', 'Refresh')}>
          <RefreshCw className="w-4 h-4" />
        </button>
      </div>
      {err ? (
        <div data-testid="revenue-error" className="text-red-600 text-sm">{L('تعذر تحميل الإحصائيات', 'Could not load stats')}</div>
      ) : !s ? (
        <div className="h-12 rounded-lg bg-slate-100 animate-pulse" />
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <Stat icon={Crown} color="bg-green-500/15 text-green-600" value={s.active_subscribers} label={L('مشتركين فعّالين', 'Active subscribers')} testId="revenue-active-subs" />
          <Stat icon={RefreshCw} color="bg-blue-50 text-blue-600" value={s.stripe_subscribers ?? 0} label={L('مشتركون عبر Stripe', 'Stripe subscribers')} testId="revenue-stripe-subs" />
          <Stat icon={DollarSign} color="bg-amber-500/15 text-amber-600" value={money(s.revenue_this_month)} label={L('إيرادات هذا الشهر', 'Revenue this month')} testId="revenue-this-month" />
          <Stat icon={Trend} color={diff >= 0 ? 'bg-emerald-500/15 text-emerald-600' : 'bg-red-500/15 text-red-600'} value={money(s.revenue_last_month)} label={`${L('الشهر الماضي', 'Last month')} • ${L('الإجمالي', 'Total')} ${money(s.revenue_total)}`} testId="revenue-last-month" />
        </div>
      )}
    </div>
  );
};

export default RevenueCard;
